import { skapi } from "@/main";
import { user } from "@/code/user";
import SkapiError from "skapi-js";

type UpdateData = Record<string, any>;

class MiscUpdater {
    private queue: {
        updateData: UpdateData;
        resolve: (value: UpdateData | PromiseLike<UpdateData>) => void;
        reject: (reason?: any) => void;
    }[] = [];

    private processing = false;
    private currentMisc: UpdateData = {};

    public update(updateData: UpdateData): Promise<UpdateData> {
        return new Promise((resolve, reject) => {
            this.queue.push({ updateData, resolve, reject });
            this.processQueue();
        });
    }

    private async processQueue(): Promise<void> {
        if (this.processing) return;
        if (this.queue.length === 0) return;

        this.processing = true;
        const { updateData, resolve, reject } = this.queue[0];

        const getProfile = await skapi.getProfile();

        if (!getProfile) {
            // 프로필이 없는 경우 (로그인 안됨 등)
            reject(new Error("User profile not available"));
            this.queue.shift();
            this.processing = false;
            this.processQueue();
            return;
        }

        if (getProfile.misc && typeof getProfile.misc === "string") {
            this.currentMisc = JSON.parse(getProfile.misc);
        } else {
            this.currentMisc = {};
        }

        let toUpdate: UpdateData = {};

        for (let key in updateData) {
            if (updateData[key] === null) {
                delete this.currentMisc[key];
            } else if (updateData[key] === this.currentMisc[key]) {
                // 변경 사항 없음
            } else {
                toUpdate[key] = updateData[key];
            }
        }

        if (Object.keys(toUpdate).length === 0) {
            // 변경 사항 없음
            resolve(this.currentMisc);
            return;
        }

        // 새 데이터 병합
        this.currentMisc = { ...this.currentMisc, ...toUpdate };

        try {
            // 서버에 저장
            await skapi.updateProfile({
                misc: JSON.stringify(this.currentMisc),
            });

            resolve(this.currentMisc);
        } catch (err) {
            reject(err);
        } finally {
            this.queue.shift();
            this.processing = false;
            this.processQueue(); // 다음 실행
        }
    }
}

export const miscUpdater = new MiscUpdater();
